import { uniqueId } from 'lodash';
import {
  AiOutlineFontSize,
  AiOutlineCheckSquare,
  AiOutlineOrderedList,
  AiOutlineAppstore,
  AiOutlineHighlight,
  AiOutlinePicture,
  AiOutlineSwap,
} from 'react-icons/ai';

// Single source of truth for question types: label, short description, editor hint and icon
export const QUESTION_TYPES = [
  { value: 'type1', title: 'equalText', desc: 'ql_type1_desc', hint: 'ql_hint_type1', icon: AiOutlineFontSize },
  { value: 'type2', title: 'multySeleteAnswer', desc: 'ql_type2_desc', hint: 'ql_hint_type2', icon: AiOutlineCheckSquare },
  { value: 'type3', title: 'sortAnswers', desc: 'ql_type3_desc', hint: 'ql_hint_type3', icon: AiOutlineOrderedList },
  { value: 'type4', title: 'sortAnswersCategories', desc: 'ql_type4_desc', hint: 'ql_hint_type4', icon: AiOutlineAppstore },
  { value: 'type5', title: 'equalTextVariants', desc: 'ql_type5_desc', hint: 'ql_hint_type5', icon: AiOutlineHighlight },
  { value: 'type6', title: 'imageLabel', desc: 'ql_type6_desc', hint: 'ql_hint_type6', icon: AiOutlinePicture },
  { value: 'type7', title: 'matchingQuestions', desc: 'ql_type7_desc', hint: 'ql_hint_type7', icon: AiOutlineSwap },
];

export const getQuestionType = (value) => QUESTION_TYPES.find(_t => _t.value === value) || QUESTION_TYPES[0];

export const newId = (prefix = 'answer-') => uniqueId(prefix) + Date.now();

export const newAnswerItem = (order = 1, isTrue = false) => ({
  _id: newId('answer-'),
  text: '',
  url: '',
  order,
  isTrue,
});

export const newCategory = () => ({
  _id: newId('answer-'),
  title: '',
  url: '',
  variants: [{ ...newAnswerItem(1), _id: newId('variant-') }],
});

export const newPair = () => ({ _id: newId('variant-'), question: '', answer: '' });

// Empty answers structure for each type (the shape the learner view and the backend expect)
export const createEmptyAnswers = (type) => {
  switch (type) {
    case 'type1':
      return '';
    case 'type2':
      return [newAnswerItem(1, true), newAnswerItem(2), newAnswerItem(3)];
    case 'type3':
      return [newAnswerItem(1), newAnswerItem(2), newAnswerItem(3)];
    case 'type4':
      return [newCategory()];
    case 'type5':
      return { value: '', variants: [] };
    case 'type6':
      return { image: '', variants: [] };
    case 'type7':
      return [newPair()];
    default:
      return '';
  }
};

export const BLANK = '___';

export const countBlanks = (text = '') => (text.match(/___/g) || []).length;

// Comma separated list of accepted variants -> clean array
export const splitVariants = (value = '') => String(value).split(',').map(_v => _v.trim()).filter(Boolean);

// A–Z markers for answer options
export const letter = (index) => String.fromCharCode(65 + (index % 26));
